module.exports = __webpack_public_path__ + "static/img/16.32820d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/hearthstone/ranks/16.png
// module id = pU87
// module chunks = 35